module.exports = __webpack_public_path__ + "img/ico-search-gray.8206fcbc.svg";